
(function($) {
	
"use strict";


  //Load Varian name first
  $('.product-form__input').each(function(){
      $(this).find('.optionselected').text( $(this).find('.cetchvaluechecked').text())
  })
  $('.customradio').on('click', function(){ 
    $(this).parent('.option-grid').siblings('.form__label').find('.optionselected').text($(this).data('name'))
  })

  //Product Descript trim
  $('.resize-description').on('click', function(){
        let btnTextName = $('.resize-description').text();
        $(this).prev('.product-description').toggleClass('show-full');
        $(this).text(btnTextName === $('.resize-description').data('show') ? $('.resize-description').data('hide') : $('.resize-description').data('show'));
  });


})(jQuery); //jQuery